// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateDocumentSummaryPromptMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateDocumentSummaryPromptInput;
}>;


export type CreateDocumentSummaryPromptMutation = { __typename?: 'Mutation', createDocumentSummaryPrompt: { __typename?: 'DocumentSummaryPrompt', id: string, displayName: string, documentType: Types.DocumentSummaryPromptDocumentType, isSystemPrompt: boolean, shouldAutoRun: boolean, isDefaultForDocType: boolean } };

export const Operations = {
  Mutation: {
    CreateDocumentSummaryPrompt: 'CreateDocumentSummaryPrompt' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const CreateDocumentSummaryPromptDocument = gql`
    mutation CreateDocumentSummaryPrompt($input: AugmentedCreateDocumentSummaryPromptInput!) {
  createDocumentSummaryPrompt(input: $input) {
    id
    displayName
    documentType
    isSystemPrompt
    shouldAutoRun
    isDefaultForDocType
  }
}
    `;
export type CreateDocumentSummaryPromptMutationFn = Apollo.MutationFunction<CreateDocumentSummaryPromptMutation, CreateDocumentSummaryPromptMutationVariables>;

/**
 * __useCreateDocumentSummaryPromptMutation__
 *
 * To run a mutation, you first call `useCreateDocumentSummaryPromptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentSummaryPromptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentSummaryPromptMutation, { data, loading, error }] = useCreateDocumentSummaryPromptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentSummaryPromptMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentSummaryPromptMutation, CreateDocumentSummaryPromptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentSummaryPromptMutation, CreateDocumentSummaryPromptMutationVariables>(CreateDocumentSummaryPromptDocument, options);
      }
export type CreateDocumentSummaryPromptMutationHookResult = ReturnType<typeof useCreateDocumentSummaryPromptMutation>;
export type CreateDocumentSummaryPromptMutationResult = Apollo.MutationResult<CreateDocumentSummaryPromptMutation>;
export type CreateDocumentSummaryPromptMutationOptions = Apollo.BaseMutationOptions<CreateDocumentSummaryPromptMutation, CreateDocumentSummaryPromptMutationVariables>;